import { Link } from "react-router-dom";
import { formatLabDate } from "../utils/datetime";

function PastLabs({ labs, isLoading, error }) {
  return (
    <section id="past-labs" className="section">
      <div className="container">
        <h2>Past Labs &amp; Resources</h2>

        {isLoading ? <p>Loading past labs...</p> : null}
        {error ? <p className="status-message error">{error}</p> : null}

        {!isLoading && !error && labs.length === 0 ? (
          <p>
            Recordings will appear here after our first Lab. You can register now to
            get the invite and recording automatically.
          </p>
        ) : null}

        {!isLoading && !error
          ? labs.map((lab) => (
              <article key={lab.id} className="card lab-card">
                <p className="eyebrow">{formatLabDate(lab.dateTime)}</p>
                <h3>{lab.title}</h3>
                <p>{lab.shortDescription}</p>
                <Link className="text-link-inline" to={`/lab/${lab.id}`}>
                  View details
                </Link>
              </article>
            ))
          : null}
      </div>
    </section>
  );
}

export default PastLabs;
